import { defineMessages } from 'react-intl';

export const messages: {
	googleDocsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	googleSlidesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	googleSheetsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	msWordLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	msPowerpointLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	msExcelLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	documentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spreadsheetLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	presentationLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fileLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	databaseLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	webPageLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pageLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	blogpostLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dashboardLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invoiceLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	designLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dealLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	videoLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spaceLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	repositoryLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	branchLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commitLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pullRequestLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	workItemLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	customerOrgLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	imageLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	archiveLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	audioLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pdfLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	codeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	channelLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	knowledgeArticleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	newsArticleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	otherLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	googleDocsLabel: {
		id: 'document-search-result.google-docs-label',
		defaultMessage: 'Docs',
		description:
			'Badge label shown on a search result to indicate the content is a Google Docs document.',
	},
	googleSlidesLabel: {
		id: 'document-search-result.google-slides-label',
		defaultMessage: 'Slides',
		description:
			'Badge label shown on a search result to indicate the content is a Google Slides presentation.',
	},
	googleSheetsLabel: {
		id: 'document-search-result.google-sheets-label',
		defaultMessage: 'Sheets',
		description:
			'Badge label shown on a search result to indicate the content is a Google Sheets spreadsheet.',
	},
	msWordLabel: {
		id: 'document-search-result.ms-word-label',
		defaultMessage: 'Word',
		description:
			'Badge label shown on a search result to indicate the content is a Microsoft Word document.',
	},
	msPowerpointLabel: {
		id: 'document-search-result.ms-powerpoint-label',
		defaultMessage: 'PowerPoint',
		description:
			'Badge label shown on a search result to indicate the content is a Microsoft PowerPoint presentation.',
	},
	msExcelLabel: {
		id: 'document-search-result.ms-excel-label',
		defaultMessage: 'Excel',
		description:
			'Badge label shown on a search result to indicate the content is a Microsoft Excel spreadsheet.',
	},

	documentLabel: {
		id: 'document.label',
		defaultMessage: 'Document',
		description:
			'Badge label shown on a search result to categorize the content as a generic document.',
	},
	spreadsheetLabel: {
		id: 'spreadsheet.label',
		defaultMessage: 'Spreadsheet',
		description: 'Badge label shown on a search result to categorize the content as a spreadsheet.',
	},
	presentationLabel: {
		id: 'presentation.label',
		defaultMessage: 'Presentation',
		description:
			'Badge label shown on a search result to categorize the content as a presentation.',
	},
	fileLabel: {
		id: 'file.label',
		defaultMessage: 'File',
		description:
			'Badge label shown on a search result to categorize the content as a generic file.',
	},
	databaseLabel: {
		id: 'database.label',
		defaultMessage: 'Database',
		description: 'Badge label shown on a search result to categorize the content as a database.',
	},
	webPageLabel: {
		id: 'web-page.label',
		defaultMessage: 'Web Page',
		description: 'Badge label shown on a search result to categorize the content as a web page.',
	},
	pageLabel: {
		id: 'page.label',
		defaultMessage: 'Page',
		description:
			'Badge label shown on a search result to categorize the content as a page (e.g. a Confluence page).',
	},
	blogpostLabel: {
		id: 'blogpost.label',
		defaultMessage: 'Blogpost',
		description: 'Badge label shown on a search result to categorize the content as a blog post.',
	},
	dashboardLabel: {
		id: 'dashboard.label',
		defaultMessage: 'Dashboard',
		description: 'Badge label shown on a search result to categorize the content as a dashboard.',
	},
	invoiceLabel: {
		id: 'invoice.label',
		defaultMessage: 'Invoice',
		description: 'Badge label shown on a search result to categorize the content as an invoice.',
	},
	designLabel: {
		id: 'design.label',
		defaultMessage: 'Design',
		description:
			'Badge label shown on a search result to categorize the content as a design file (e.g. Figma or Canva).',
	},
	dealLabel: {
		id: 'deal.label',
		defaultMessage: 'Deal',
		description:
			'Badge label shown on a search result to categorize the content as a sales deal (e.g. from Salesforce or HubSpot).',
	},
	videoLabel: {
		id: 'video.label',
		defaultMessage: 'Video',
		description: 'Badge label shown on a search result to categorize the content as a video.',
	},
	taskLabel: {
		id: 'task.label',
		defaultMessage: 'Task',
		description: 'Badge label shown on a search result to categorize the content as a task.',
	},
	issueLabel: {
		id: 'issue.label',
		defaultMessage: 'Issue',
		description:
			'Badge label shown on a search result to categorize the content as an issue (e.g. a Jira or GitHub issue).',
	},
	spaceLabel: {
		id: 'space.label',
		defaultMessage: 'Space',
		description:
			'Badge label shown on a search result to categorize the content as a space (e.g. a Confluence space).',
	},
	projectLabel: {
		id: 'project.label',
		defaultMessage: 'Project',
		description: 'Badge label shown on a search result to categorize the content as a project.',
	},
	repositoryLabel: {
		id: 'repository.label',
		defaultMessage: 'Repository',
		description:
			'Badge label shown on a search result to categorize the content as a code repository (e.g. GitHub or Bitbucket).',
	},
	branchLabel: {
		id: 'branch.label',
		defaultMessage: 'Branch',
		description: 'Badge label shown on a search result to categorize the content as a code branch.',
	},
	commitLabel: {
		id: 'commit.label',
		defaultMessage: 'Commit',
		description: 'Badge label shown on a search result to categorize the content as a code commit.',
	},
	pullRequestLabel: {
		id: 'pull-request.label',
		defaultMessage: 'Pull Request',
		description:
			'Badge label shown on a search result to categorize the content as a pull request.',
	},
	workItemLabel: {
		id: 'work-item.label',
		defaultMessage: 'Work Item',
		description: 'Badge label shown on a search result to categorize the content as a work item.',
	},
	customerOrgLabel: {
		id: 'customer-org.label',
		defaultMessage: 'Customer Org',
		description:
			'Badge label shown on a search result to categorize the content as a customer organization record.',
	},
	imageLabel: {
		id: 'image.label',
		defaultMessage: 'Image',
		description: 'Badge label shown on a search result to categorize the content as an image file.',
	},
	archiveLabel: {
		id: 'archive.label',
		defaultMessage: 'Archive',
		description:
			'Badge label shown on a search result to categorize the content as an archive file (e.g. ZIP or TAR).',
	},
	audioLabel: {
		id: 'audio.label',
		defaultMessage: 'Audio',
		description: 'Badge label shown on a search result to categorize the content as an audio file.',
	},
	pdfLabel: {
		id: 'pdf.label',
		defaultMessage: 'PDF',
		description:
			'Badge label shown on a search result to categorize the content as a PDF document.',
	},
	codeLabel: {
		id: 'code.label',
		defaultMessage: 'Code',
		description:
			'Badge label shown on a search result to categorize the content as a code file or snippet.',
	},
	channelLabel: {
		id: 'channel.label',
		defaultMessage: 'Channel',
		description:
			'Badge label shown on a search result to categorize the content as a messaging channel (e.g. a Slack channel).',
	},
	knowledgeArticleLabel: {
		id: '3p-result-labeling.knowledge_article.label',
		defaultMessage: 'Knowledge article',
		description: 'Label for third-party graph document results with knowledge article subtype.',
	},
	newsArticleLabel: {
		id: '3p-result-labeling.news_article.label',
		defaultMessage: 'News article',
		description: 'Label for third-party graph document results with news article subtype.',
	},
	otherLabel: {
		id: 'other.label',
		defaultMessage: 'Other',
		description:
			'Badge label shown on a search result when the content subtype does not match any known category.',
	},
});
